export const getUser = () => {
  const userStr = localStorage.getItem("user");
  if (userStr !== "undefined") return JSON.parse(userStr);
  else return null;
};

export const getToken = () => {
  return localStorage.getItem("token");
};
export const setUserSession = (token, user) => {
  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify(user));
};
export const removeUserSession = (history) => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  history.push("/login");
};
